import { CountryCode, Locality, country, fromGooglePlaceResult } from "@zickko/shared";
import { GooglePlaceAutocompleteInput } from "../elements/GooglePlaceAutocompleteInput";
import { FormItemContainer, FormItemProps } from "./FormItemContainer";

type Props = FormItemProps<Locality> & {
  value?: Locality;
  onChange: (value?: Locality) => void;
  dataCy?: string;
  helpText?: string;
};

function getLocalityLabel(locality: Locality | undefined): string {
  if (!locality) return "";
  return `${locality?.suburb}${locality?.suburb && ", "}${locality?.state}, ${
    locality?.countryCode && country.getForCode(locality.countryCode as CountryCode)?.name
  }`;
}

export const FormLocalityInput = (props: Props) => {
  //
  const currentValue = getLocalityLabel(props.value);
  return (
    <FormItemContainer
      label="Locality"
      validation={props.validation}
      helpText={props.helpText}
      additionalClassNames={`form-locality-input ${props.additionalClassNames}`}
    >
      <GooglePlaceAutocompleteInput
        onChange={(placeResult) => {
          if (!placeResult) return;
          const locality = fromGooglePlaceResult.getLocality({ placeResult });
          props.onChange(locality);
          console.log(locality);
        }}
        typeFilter={"regions"}
        currentLocation={currentValue}
      />
    </FormItemContainer>
  );
};
